export const APP_ENV_PRODUCTION = 'production';
export const APP_ENV_STAGING = 'staging';
export const APP_ENV_DEVELOPMENT = 'development';
export const ADMIN= 'admin';
export const CDN_LINK = 'https://cdn.venuemonk.com';